<template>
    <div class="cc-invoice-address-summary">
        <div class="cc-invoice-address-summary__header">
            <div class="cc-invoice-address-summary__title">{{ translations['Invoice address summary'] }}</div>
        </div>
        <div class="cc-invoice-address-summary__main">
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.firstname">{{ invoiceAddress.firstname }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.lastname">{{ invoiceAddress.lastname }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.addressLine1">{{ invoiceAddress.addressLine1 }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.city">{{ invoiceAddress.city }}</div>
            <div class="cc-delivery-address-summary__item" v-if="invoiceAddress.country">{{ countryName }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.postalCode">{{ invoiceAddress.postalCode }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.phone">{{ invoiceAddress.phone }}</div>
            <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.email">{{ invoiceAddress.email }}</div>
            <div class="cc-delivery-address-summary__group" v-if="isCompanyInformationEntered">
                <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.company">{{ invoiceAddress.company }}</div>
                <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.identificationNumber">{{ invoiceAddress.identificationNumber }}</div>
                <div class="cc-invoice-address-summary__item" v-if="invoiceAddress.taxIdentificationNumber">{{ invoiceAddress.taxIdentificationNumber }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                invoiceAddress: state => state.user.invoiceAddress,
                countries: state => state.config.countries,
            }),
            countryName: function() {
                for (let key in this.countries) {
                    if (!this.countries.hasOwnProperty(key)) {
                        continue;
                    }

                    if (this.countries[key].id === this.invoiceAddress.country) {
                        return this.countries[key].name;
                    }
                }

                return '';
            },
            isCompanyInformationEntered: function () {
                return this.invoiceAddress.company || this.invoiceAddress.identificationNumber || this.invoiceAddress.taxIdentificationNumber;
            },
        },
        name: 'InvoiceAddressSummary',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-invoice-address-summary {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-invoice-address-summary__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-invoice-address-summary__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-invoice-address-summary__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }

        .cc-delivery-address-summary__group {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
